package com.cybersoftsolution.cybersoftsolutionweb.components.text

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.coroutines.delay

@Composable
fun WritableSpanText(
    id: String,
    modifier: Modifier = Modifier,
    initialText: String = "",
    fullText: String,
    runEffect: Boolean = false,
    onCompleteEffect: () -> Unit = {},
){
    var textInProgress by remember { mutableStateOf(initialText) }

    SpanText(
        modifier = Modifier
            .id(id)
                then(modifier),
        text = textInProgress
    )


    LaunchedEffect(runEffect) {
        if (runEffect) {
            fullText.forEachIndexed { index, _ ->
                textInProgress = fullText.substring(0, index + 1)
                delay(50)
                if (index == fullText.length - 1) {
                    onCompleteEffect()
                }
            }
        }
    }

}